/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_PerformanceRuleListDto } from '../models/PagedResultDto_PerformanceRuleListDto';
import type { Wealthlane_AwardService_Dtos_Common_DropdownDto } from '../models/Wealthlane_AwardService_Dtos_Common_DropdownDto';
import type { Wealthlane_AwardService_Dtos_Common_IntDropdownDto } from '../models/Wealthlane_AwardService_Dtos_Common_IntDropdownDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_RejectPerformanceRuleDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_RejectPerformanceRuleDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PerformanceRuleApprovalService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleApprovalPerformanceRuleTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule-approval/performance-rule-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleApprovalRuleAvailableStatusList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule-approval/rule-available-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleApprovalRuleApprovalStatusList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule-approval/rule-approval-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param evaluationPeriodFrom
     * @param evaluationPeriodTo
     * @param approvalStatus
     * @param ruleStatus
     * @param earnedStatus
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_PerformanceRuleListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleApprovalApprovalPerformanceRuleList(
        evaluationPeriodFrom?: string,
        evaluationPeriodTo?: string,
        approvalStatus?: Array<number>,
        ruleStatus?: number,
        earnedStatus?: number,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_PerformanceRuleListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule-approval/approval-performance-rule-list',
            query: {
                'EvaluationPeriodFrom': evaluationPeriodFrom,
                'EvaluationPeriodTo': evaluationPeriodTo,
                'ApprovalStatus': approvalStatus,
                'RuleStatus': ruleStatus,
                'EarnedStatus': earnedStatus,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleApprovalRuleEarnedlStatusList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule-approval/rule-earnedl-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleApprovalApprovalPerformanceRulesById(
        id: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule-approval/{id}/approval-performance-rules-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRuleApprovalApprovePerformanceRule(
        id: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule-approval/{id}/approve-performance-rule',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRuleApprovalRejectPerformanceRule(
        requestBody?: Wealthlane_AwardService_Dtos_PerformanceRule_RejectPerformanceRuleDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule-approval/reject-performance-rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
